export default "__VITE_ASSET__cvIGJjjv__"